var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBackup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.335 29.666a2.568 2.568 0 01-1.884-.783A2.568 2.568 0 01.668 27V3c0-.734.261-1.361.783-1.884A2.568 2.568 0 013.335.333h13.333c.733 0 1.361.261 1.883.783.523.523.784 1.15.784 1.884v24c0 .733-.262 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H3.335zm0-6.666h13.333V7H3.335v16z",
    fill: "#7A8D8F"
  })));
}
export default SvgMobileBackup;